import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";

import "react-datetime/css/react-datetime.css";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useSelector } from "react-redux";

import useAxiosFile from "../../actions/useaxios";

import { useNavigate } from "react-router";
import { LoadToast, updateToast } from "../../actions/common";

import { FaXTwitter } from "react-icons/fa6";

function lists() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const axiosFile = useAxiosFile();

  useEffect(() => {
    datalist();
  }, []);

  const datalist = async () => {
    var data = await axiosFile.datalist();
    console.log("vvvv", data);
    setList(data?.data);
  };

  const submitbtn = async (cell) => {
    console.log("ccc", cell);
    navigate(`/add/?id=${cell._id}`);
  };

  const clickbtn = async (cell) => {
    const id = LoadToast();
    console.log("ccc", cell);
    const updatedata = {
      _id: cell._id,
      action: "statusupdate",
      status: true,
    };
    var data = await axiosFile.addinsert(updatedata);
    console.log("ttttttttrue", data);
    updateToast(id, data.msg, data.success);
    if (data?.success == "success") {
      datalist();
    }
  };
  const columns = [
    {
      dataField: "icon",
      text: "icon",
      sort: true,
      formatter: (cell, row) => (
        <>
          {
            row?.website == 'twitter'
              ?
              <FaXTwitter />
              :
              <div dangerouslySetInnerHTML={{ __html: cell }}>
              </div>
          }
        </>
      ),
    },
    {
      dataField: "website",
      text: "website",
      sort: true,
      formatter: (cell, row) => <div>{cell}</div>,
    },
    {
      dataField: "link",
      text: "link",
      sort: true,
      formatter: (cell, row) => (
        <a href={cell} target="_blank" className="theme_link">
          {cell}
        </a>
      ),
    },
    {
      dataField: "hideshow",
      text: "Edit",
      formatter: (cell, row) => (
        <button
          class="theme_btn"
          type="button"
          onClick={() => submitbtn(row)}
        >
          Edit
        </button>
      ),
    },
    // {
    //   dataField: "hideshow",
    //   text: "Delete",
    //   formatter: (cell, row) => (
    //     <button
    //       class="btn table_viewdrop"
    //       type="button"
    //       onClick={() => clickbtn(row)}
    //     >
    //       delete
    //     </button>
    //   ),
    // },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">Social Links</p>
            </div>
            <div className="rightsec">
              {/* <button
                            type="button"
                            className="blue_btn add_deliveryprsn dp_btn_hover"
                            onClick={() => navigate("/add")}
                          >
                            Add
                          </button> */}
            </div>
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row">
              {
                <div className="ffd_table mar_bot vendor_table_align">
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    columns={columns}
                    data={list}
                    pagination={pagination}
                    noDataIndication="No Social Links found"
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default lists;
